export default __webpack_public_path__ + "static/media/cert-student-consumer-sc.857a4190.jpg";